module.exports = __webpack_public_path__ + "static/media/bg.bbf32dd0.png";